// Barre d'achat mobile : apparaît quand le bouton « Ajouter au panier » principal n'est pas visible à l'écran.
if (!customElements.get('hf-sticky-atc')) {
  customElements.define(
    'hf-sticky-atc',
    class HfStickyAtc extends HTMLElement {
      connectedCallback() {
        // Rattachée au body : les animations de Dawn (transform) casseraient position: fixed.
        if (this.parentElement !== document.body) {
          document.body.appendChild(this);
          return;
        }
        if (this.onScroll) return;
        this.selector = `#ProductInfo-${this.dataset.section} product-form button[name="add"]`;
        this.querySelector('[data-sticky-add]').addEventListener('click', () => {
          document.querySelector(this.selector)?.click();
        });

        this.onScroll = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            // Le bouton peut être remplacé par Dawn au changement de variante : on le cherche à chaque fois.
            const button = document.querySelector(this.selector);
            // Visible tant que le bouton principal n'est pas entièrement à l'écran.
            const rect = button?.getBoundingClientRect();
            this.hidden = !rect || (rect.top >= 0 && rect.bottom <= window.innerHeight);
          });
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.onScroll();
      }

      disconnectedCallback() {
        if (this.isConnected) return;
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        this.onScroll = null;
      }
    }
  );
}
